import { hasUserPermission, type User } from '@controlstock/contracts';

export function userHomePath(user: User | undefined): string {
  if (user?.role === 'ML_INTEGRATOR') return '/conectar-mercadolibre';
  if (hasUserPermission(user, 'dashboard.read')) return '/dashboard';
  if (hasUserPermission(user, 'inventory.read')) return '/inventario';
  if (hasUserPermission(user, 'sales.read')) return '/ventas/pedidos';
  return '/sin-acceso';
}
